import { useNowContext } from "@hq/client-react";
import type { NowContext } from "@hq/core";

/**
 * The clock every component in this package reads. An explicit `now` prop wins so tests and
 * embedding surfaces can pin the instant; otherwise the shared ticking wall clock is used.
 */
export function useNow(override?: NowContext): NowContext {
  const live = useNowContext();
  return override ?? live;
}
